import petrolImg from "../assets/petrol.png"
import constructionImg from "../assets/tracksmart.jpg"

const defaultUseCases = [
  {
    number: "01",
    title: "Logistics & Transportation",
    desc: "Ensure timely deliveries, improve route efficiency, and monitor fleet movement with real-time vehicle tracking and location visibility.",
    image: petrolImg,
  },
  {
    number: "02",
    title: "Construction",
    desc: "Monitor equipment usage, track site vehicles, prevent unauthorized use, and optimize asset allocation across construction projects.",
    image: constructionImg,
  },
  {
    number: "03",
    title: "Field Services",
    desc: "Optimize technician dispatch, monitor service calls, reduce response times, and improve customer satisfaction with live fleet visibility.",
    image: constructionImg,
  },
  {
    number: "04",
    title: "Healthcare",
    desc: "Track medical transport, ambulance movement, and emergency service vehicles to improve response time and patient safety.",
    image: petrolImg,
  },
]

function UseCaseCard({ item }) {
  return (
    <div className="relative h-[350px] w-full max-w-[400px] overflow-hidden rounded-3xl shadow-lg transition-all duration-500 hover:-translate-y-1 hover:shadow-xl group">
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
        style={{ backgroundImage: `url(${item.image || petrolImg})` }}
      >
        <div className="absolute inset-0 bg-black/40 transition-all duration-500 group-hover:bg-black/50" />
      </div>

      <div className="absolute bottom-0 left-0 p-8 w-full transition-all duration-500 group-hover:bottom-12">
        <span className="text-white/80 block mb-2 text-sm font-bold">{item.number}</span>
        <h3 className="text-white text-2xl font-bold mb-4 leading-tight">{item.title}</h3>
        <p className="text-white/90 text-sm leading-relaxed">{item.desc}</p>
      </div>
    </div>
  )
}

export default function UseCasesSection({
  title = "Who Uses Vehicle Tracking Systems?",
  desc = "Our solutions are trusted by various industries to optimize their fleet operations.",
  items = defaultUseCases,
}) {
  const resolvedItems = items && items.length ? items : defaultUseCases

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#111111]">{title}</h2>
          <div className="w-20 h-1 bg-[#df8b2d] mx-auto mt-4" />
          <p className="mx-auto mt-6 max-w-[760px] text-sm leading-relaxed text-gray-600 sm:text-base">
            {desc}
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8">
          {resolvedItems.map((item, index) => (
            <UseCaseCard key={`${item.number}-${index}`} item={item} />
          ))}
        </div>
      </div>
    </section>
  )
}
